// extracted by mini-css-extract-plugin
export default {"multiplier":"Multiplier_multiplier__w2Xeu"};